const artistsWishlistPT = {
    "view": {
        "table": {
            "title": "Sua lista de desejos de artistas",
            "column": {
                "artist_name": "Nome do Artista",
                "spotify_id": "ID do Spotify",
                "followers": "Seguidores",
                "popularity": "Popularidade (%)",
                "action": "Ação"
            },
            "dropdown": {
                "action": "Ação",
                "addAsArtist": "Adicionar como Artista",
                "delete": "Excluir"
            },
            "button": {
                "export_csv": "Exportar CSV"
            },
            "placeholder": {
                "search": "Pesquisar..."
            },
            "message": {
                "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
            }
        },
        "modal": {
            "removeArtist": {
                "header": "Remover Artista {{artistName}} Da Lista de Desejos",
                "body": "Tem certeza de que deseja remover o artista {{artistName}} da sua lista de desejos?"
            }
        },
        "message": {
            "subscriptionUpgrade": "Seu plano de assinatura atual não suporta este recurso. Por favor, <1>atualize</1> seu plano de assinatura para aproveitar este recurso.",
            "subscriptionExpired": "Sua assinatura expirou. Por favor, <1>retome</1> sua assinatura para aproveitar este recurso.",
            "noAccess": "Você não tem acesso a este módulo, por favor, entre em contato com a equipe de suporte para mais informações."
        }
    }
};

export default artistsWishlistPT;